import { motion } from "framer-motion";
import { customerLogos } from "@/data/customerLogos";

interface LogoTickerProps {
  title?: string;
  subtitle?: string;
}

export function LogoTicker({ title, subtitle }: LogoTickerProps) {
  // Duplicate logos for seamless loop
  const logos = [...customerLogos, ...customerLogos];

  return (
    <section className="py-12 lg:py-16 bg-white dark:bg-white overflow-hidden min-h-[120px]">
      <div className="container mx-auto px-4 lg:px-8">
        {(title || subtitle) && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-10"
          >
            {title && (
              <p className="text-sm font-bold font-subheading uppercase tracking-widest text-gray-500">
                {title}
              </p>
            )}
            {subtitle && (
              <p className="mt-2 text-gray-500 font-body text-sm">
                {subtitle}
              </p>
            )}
          </motion.div>
        )}
      </div>

      <div className="relative" aria-hidden="true" role="presentation">
        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-24 lg:w-40 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 lg:w-40 bg-gradient-to-l from-white to-transparent z-10" />

        <div className="flex animate-logo-scroll motion-reduce:animate-none">
          {logos.map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex-shrink-0 mx-6 lg:mx-10 flex items-center justify-center h-10 lg:h-12"
            >
              <img
                src={logo.src}
                alt=""
                width={100}
                height={40}
                className="h-8 lg:h-10 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
                loading="eager"
                style={{ aspectRatio: '100/40' }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
